import { ref } from "vue";
import { defineStore } from "pinia";
import { getCookie } from "@/utils";

export const indexStore = defineStore("index", () => {
  const title = ref<string>();
  const subtitle = ref<string>();
  const isShowRight = ref<boolean>(false);
  const isShowLeft = ref<boolean>(true);
  const bgColor = ref<string>("#FFFFFF");
  const linkPage = ref(true);
  const auth = ref();
  const isShow = ref<boolean>(false);
  const isShowHome = ref<boolean>(false);
  const showTabbar = ref<boolean>(true);

  // 设置是否允许组件自动跳转页面
  const isLinkPage = (b: boolean) => {
    linkPage.value = b;
  };
  const setShowTabbar = (b: boolean) => {
    showTabbar.value = b;
  };
  const setTitle = (t: string) => {
    title.value = t;
  };
  const setSubtitle = (t: string) => {
    subtitle.value = t;
  };
  const setRight = (t: boolean) => {
    isShowRight.value = t;
  };
  const setLeft = (t: boolean) => {
    isShowLeft.value = t;
  };
  const setBgColor = (color: string) => {
    bgColor.value = color;
  };
  const synchInfo = (success: () => void) => {
    success();
  };
  const getAuth = () => {
    return getCookie("auth");
  };
  const setAuth = (num: number) => {
    auth.value = num;
  };
  const setIsShow = (b: boolean) => {
    isShow.value = b;
  };
  const setIsShowHome = (b: boolean) => {
    isShowHome.value = b;
  };
  return {
    title,
    setTitle,
    subtitle,
    setSubtitle,
    isShowRight,
    isShowLeft,
    setRight,
    setLeft,
    isShow,
    setIsShow,
    isShowHome,
    setIsShowHome,
    synchInfo,
    bgColor,
    setBgColor,
    linkPage,
    isLinkPage,
    auth,
    getAuth,
    setAuth,
    showTabbar,
    setShowTabbar
  };
});
